<template>
  <el-menu default-active="1-1">
    <el-submenu index="1">
      <template slot="title">
        <i class="el-icon-location"></i>
        <span>Οι Συνομιλίες μου</span>
      </template>
      <el-menu-item v-for="chat in privateChats" :key='chat.id' index="1-1" @click="openChat(chat.id, chat.label)">
        <el-popover
          placement="right"
          title="Συμμετέχοντες"
          width="300"
          trigger="hover"
          @show="chatMembers(chat.id)"
          :content="currentChatMembers">
          <div slot="reference">{{ chat.label }}
            <el-badge type="primary" v-if="calcNewMesPerRoom(chat.label) != 0"
              :value="calcNewMesPerRoom(chat.label)"
              class="item">
            </el-badge>
          </div>
        </el-popover>
      </el-menu-item>
    </el-submenu>
    <el-submenu index="2">
      <template slot="title">
        <i class="el-icon-location"></i>
        <span>Οι Ανοιχτές Συνομιλίες μου</span>
      </template>
      <el-menu-item v-for="chat in myPubliChats" :key='chat.id' index="2-1" @click="openChat(chat.id, chat.label)">
        <el-popover
          placement="right"
          title="Συμμετέχοντες"
          width="300"
          trigger="hover"
          @show="chatMembers(chat.id)"
          :content="currentChatMembers">
          <div slot="reference">{{ chat.label }}
            <el-badge type="primary" v-if="calcNewMesPerRoom(chat.label) != 0"
              :value="calcNewMesPerRoom(chat.label)"
              class="item">
            </el-badge>
          </div>
        </el-popover>
      </el-menu-item>
    </el-submenu>
    <el-submenu index="3" v-if="['SpecialProponent', 'PreChecker'].includes(activeRole)">
      <template slot="title">
        <i class="el-icon-location"></i>
        <span>Συνομιλίες με πολίτες</span>
      </template>
      <el-menu-item v-for="chat in myExternalChats" :key='chat.id' index="1-1" @click="openChat(chat.id, chat.label, 'external')">
        <el-popover
          placement="right"
          title="Συμμετέχοντες"
          width="300"
          trigger="hover">
          <div slot="reference">{{ chat.label }}
            <el-badge type="primary" v-if="calcNewMesPerExternal(chat.label) != 0"
              :value="calcNewMesPerExternal(chat.label)"
              class="item">
            </el-badge>
          </div>
        </el-popover>
      </el-menu-item>
    </el-submenu>
    <el-menu-item index="3" @click="manageRooms">
      <i class="el-icon-document"></i>
      <span>Διαχείριση Συνομιλιών</span>
    </el-menu-item>
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      currentChatMembers: ''
    }
  },
  mounted () {
    // this.$store.dispatch('GET_ALL_USERS')
  },
  computed: {
    usersNameLabels () {
      return this.internalUsers.map(function (user) {
        return {
          value: user.id,
          label: user.name + ' ' + user.surname
        }
      })
    },
    ...mapGetters({
      activeRole: 'activeRole',
      loadingInternalUsers: 'loadingInternalUsers',
      allUsers: 'allUsers',
      myChats: 'myChats',
      myExternalChats: 'myExternalChats',
      privateChats: 'privateChats',
      publicChats: 'publicChats',
      myPubliChats: 'myPubliChats',
      newMessagesPerRoom: 'newMessagesPerRoom',
      newMessagesExternals: 'newMessagesExternals'
    })
  },
  methods: {
    calcNewMesPerRoom (chatLabel) {
      return this.newMessagesPerRoom.find(ch => ch.name === chatLabel).newMessages
    },
    calcNewMesPerExternal (chatLabel) {
      return this.newMessagesExternals.find(ch => ch.name === chatLabel).newMessages
    },
    chatMembers (chatId) {
      this.currentChatMembers = this.myChats.find(chat => chat.id === chatId).users.map(user => user.name).join(', ')
    },
    openChat (id, label, external) {
      this.$emit('viewRoom')
      this.$store.dispatch('GET_CHATROOM', {id: id, page: 1, perPage: 10, external: external === 'external'})
      if (external === 'external') {
      } else {
        this.$store.dispatch('GET_CURRENT_CHATROOM_USERS', id)
        this.$store.dispatch('GET_CHATROOMS')
      }
    },
    manageRooms () {
      this.$emit('manageRooms')
    }
  }
}
</script>

<style lang="scss">
// .box-card {
//   width: 280px;
// }
li.el-menu-item.list-group-item {
  padding-left: 5px;
}
.el-submenu {
  border-radius: 20px;
  overflow-wrap: break-word;
  border: 2px solid #7fa3bb;
  padding: 5px;
  &__title:hover {
    background-color: "#b3c0d1";
  }
}
.el-menu-vertical-admin {
  margin: 5px;
  word-wrap: break-word;
  border-radius: 0px 20px;
  border: 2px solid #7fa3bb;
  padding: 10px;
}
.el-card__body {
  padding: 2px;
  // height: 40px;
}
/*.el-input--small .el-input__inner {*/
  /*width: 150px*/
/*}*/
// .el-card {
//   margin: 5px;
// }
.el-card__header {
  padding: 8px 20px;
}
.list-group-item {
  background-color: #7fa3bb;
  &:hover {
    background-color: #4d7590;
  }
  position: relative;
  display: block;
  margin-bottom: 0px;
  border: 1px solid rgba(0,0,0,.125);
  border-radius: 4px
}
.list-group {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
}
ul, menu, dir {
  display: block;
  list-style-type: disc;
  -webkit-margin-after: 1em;
  -webkit-margin-start: 0px;
  -webkit-margin-end: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/chat/ChatRooms.vue